interface Props {
  width?: number;
  height?: number;
  backgroundImage?: string;
  backgroundSize?: string;
}
const PoliceLineDivider = ({
  width,
  height,
  backgroundImage = "url('/images/line_pattern.webp')",
  backgroundSize = '28px 10px',
}: Props) => {
  return (
    <div
      className="bg-main-yellow relative h-2.5 overflow-hidden"
      style={{ height: `${height}px`, width: `${width}px` }}
    >
      <div
        className="absolute inset-0 bg-repeat-x"
        style={{
          backgroundImage,
          backgroundPosition: 'center',
          backgroundSize,
        }}
      />
    </div>
  );
};

export default PoliceLineDivider;
